/** Couleurs de jonction entre sections et vagues décoratives (accueil public). */
export const PUBLIC_SECTION_SURFACES = {
  /** Bas de #apropos (tailwind `surface`). */
  aboutEnd: '#f7f9fb',
  /** Section #filieres + jonctions programme ↓ et parcours ↑. */
  filieres: '#f5f5f5',
  /** Bas de #parcours (jonction vers #tarifs). */
  parcoursEnd: '#ffffff',
  /** Fond de la section #tarifs (cartes tarification). */
  tarifsPrograms: '#e8eaed',
  /** Fond page sous #tarifs (#vacations, etc.). */
  afterTarifs: '#f7f9fb',
} as const;
